/**
 * TanStack Query hooks for `fraud-reports-most-fraudulent-campaigns-publishers`.
 * Thin wrappers over ./api — filter params become part of the query key so
 * date-range / dim changes re-fetch cleanly.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import {
	fetchRanked,
	fraudReportsMostFraudulentCampaignsPublishersQueryKeys,
	type RankedArgs,
	type RankedResponse,
} from "./api";

export function useFraudReportsMostFraudulentCampaignsPublishersQuery(
	args: RankedArgs,
): UseQueryResult<RankedResponse, Error> {
	return useQuery({
		queryKey: fraudReportsMostFraudulentCampaignsPublishersQueryKeys.ranked(args),
		queryFn: () => fetchRanked(args),
	});
}
